import { Inject, Injectable } from '@angular/core';
import { ICreditAccountEnvironmentDetails } from './credit-account-environment-details';
import { Environment, ENVIRONMENT } from '@classifieds-sell/environment';

@Injectable({
    providedIn: 'root'
})
export class CreditAccountEnvironmentService {
    constructor(@Inject(ENVIRONMENT) private env: Environment) {}

    public getCreditAccountEnvironmentDetails(): ICreditAccountEnvironmentDetails {
        return <ICreditAccountEnvironmentDetails> {
            paymentsUrl: this.env.paymentWidgetUrl,
            apiBaseUrlForGringotts: this.env.apiBaseUrlForGringotts,
            isProduction: this.env.production
        };
    }
}
